//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import configuracaoApuracaoAcordoResource from '../../common/resources/configuracao/configuracao-apuracao-acordo';

import { copyObject } from '../../common/functions/helpers'; // eslint-disable-line

export default {
  name: 'ConfiguracaoApuracao',
  data() {
    return {
      configuracaoApuracaoAcordoResources: configuracaoApuracaoAcordoResource(this.$resource),
      contratos: [],
      negociacoes: [],
      configuracoesContrato: [],
      tipoAcordo: '',
      disableCheck: false,
    };
  },
  computed: {
    hasConfiguracoesContrato() {
      return !!(this.configuracoesContrato && this.configuracoesContrato.length);
    },
    grupos() {
      return this.hasConfiguracoesContrato ?
        this._.groupBy(this.configuracoesContrato, el => el.nomeGrupo) :
        [];
    },
    contratosCombobox() {
      return this.contratos.length ?
        this.contratos.filter(el => el.valor) :
        [];
    },
  },
  methods: {
    convertToBool() {
      this.contratos.forEach((el) => {
        el.valor = el.valor === 'true';
      });
    },
    copyObject(el) {
      if (el.valor === true) {
        this.contratosCombobox.push(el);
      }
    },
    requestAtualizarConfiguracao(item, $event) {
      if (!this.disableCheck) {
        this.disableCheck = true;
        setTimeout(() => {
          item.valor = $event;

          this.configuracaoApuracaoAcordoResources.atualizarConfiguracoesApuracaoAcordo(item)
            .catch((err) => {
              this.$error(this, err);
            });

          this.disableCheck = false;
        }, 500);
      }
    },
    requestAtualizarSubConfiguracao(item) {
      if (!this.disableCheck) {
        this.disableCheck = true;
        setTimeout(() => {
          this.configuracaoApuracaoAcordoResources.atualizarSubConfiguracoesApuracaoAcordo(item)
            .then(() => {
              this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
            })
            .catch((err) => {
              this.$error(this, err);
            });

          this.disableCheck = false;
        }, 500);
      }
    },
    requestPopular() {
      this.configuracaoApuracaoAcordoResources.pesquisar()
        .then((response) => {
          const objeto = response.data;
          if (!objeto || !objeto.length) {
            return;
          }

          this.contratos = objeto.filter(el => el.idConfiguracao === 'ACORDO').map((el) => {
            el.valor = el.valor === 'true';
            return el;
          });

          if (this.contratos) {
            this.requestPrimeiroContrato();
          }
        });
    },
    requestPopularConfiguracoesContrato({ nomeAcordo }) {
      this.configuracaoApuracaoAcordoResources.pesquisarConfiguracoesApuracaoAcordo(
        { nomeAcordo }, {})
        .then((response) => {
          const objeto = response.data;
          this.configuracoesContrato = objeto.map((el) => {
            el.vlrSelecao = el.valor === 'true';
            return el;
          });
        });
    },
    requestPrimeiroContrato() {
      if (this.contratosCombobox.length) {
        const selected = this.contratosCombobox[0];
        this.tipoAcordo = selected.nomeAcordo;
        this.requestPopularConfiguracoesContrato(selected);
      }
    },
  },
  mounted() {
    this.requestPopular();
  },
};



// WEBPACK FOOTER //
// ./src/spa/configuracao/ConfiguracaoApuracaoAcordo.vue?vue&type=script&lang=js&